const STORE_KEY = '__workflows';

module.exports = (flex = window.flex) => {

    const { getStore, setStore, uuid } = flex;

    return (uniqueId, autoRewind) => {
        let stepCount;
        if (!uniqueId) {
            uniqueId = uuid();
        }
        if (typeof (autoRewind) === 'undefined') {
            autoRewind = true;
        }
        initialize(uniqueId);
        const loadStore = () => getStore().toJS()[STORE_KEY][uniqueId];
        const persist = (data) => {
            let store = flex.getStore(),
                workflows = store[STORE_KEY],
                nextStore = {};

            nextStore[STORE_KEY] = Object.assign({}, workflows);
            nextStore[STORE_KEY][uniqueId] = Object.assign({}, data);

            setStore(nextStore);
        };
        const setActiveStep = (stepIndex) => {
            let newStepIndex = stepIndex;
            if (newStepIndex < 0) {
                newStepIndex = 0;
            }
            if (stepCount && newStepIndex >= stepCount) {
                newStepIndex = stepCount - 1;
            }
            persist(Object.assign(loadStore(), { activeStepIndex: newStepIndex }));
        };
        const doRewind = (stepIndex) => {
            let store = loadStore(),
                { stepKeys, values } = store,
                rewound = false;

            stepKeys.forEach((keys, index) => {
                if (index <= stepIndex) {
                    return;
                }
                rewound = true;
                keys.forEach(key => {
                    delete values[key];
                });
            });

            if (rewound) {
                persist(store);
            }
        };
        const rewindToStep = (stepIndex) => {
            if (!loadStore().activeStepIndex > stepIndex) {
                return;
            }
            doRewind(stepIndex);
            setActiveStep(stepIndex);
        };
        return {
            activeStepIndex: () => loadStore().activeStepIndex,
            errorMessages: () => loadStore().errorMessages,
            isFirstStep: () => {
                return loadStore().activeStepIndex === 0;
            },
            isLastStep: () => {
                return loadStore().activeStepIndex >= stepCount - 1;
            },
            setValue: (stepIndex, key, value, rewind = autoRewind) => {
                if (rewind) {
                    rewindToStep(stepIndex);
                }

                let store = loadStore(),
                    { values, stepKeys } = store;

                // Save how we got to this data for rewinding purposes
                if (!stepKeys[stepIndex]) {
                    stepKeys[stepIndex] = [];
                }
                if (!stepKeys[stepIndex].includes(key)) {
                    stepKeys[stepIndex].push(key);
                }

                values[key] = value;
                persist(Object.assign(store, { values, stepKeys }));
            },
            setStepComplete: (stepIndex) => {
                setActiveStep(stepIndex + 1);
            },
            setStepPrevious: () => {
                setActiveStep(loadStore().activeStepIndex - 1);
            },
            setStepCount: (count) => {
                stepCount = count;
            },
            setWorkflowComplete: (stepIndex) => {
                setActiveStep(Infinity);
                // workflowcomplete
            },
            setValidity(key, value) {
                let store = loadStore(),
                    { validity } = store;

                validity[key] = value;
                persist(Object.assign(store, { validity }));
            },
            values: () => loadStore().values,
            validity: () => loadStore().validity
        }
    };

    function initialize(uniqueId) {
        const defaultState = {
            activeStepIndex: 0,
            errorMessages: [],
            values: {},
            stepKeys: [],
            validity: {}
        };
        let store = getStore().toJS();

        if (!store[STORE_KEY]) {
            let workflowStoreInit = {};
            workflowStoreInit[STORE_KEY] = {};
            store = setStore(workflowStoreInit).toJS();
        }

        if (store[STORE_KEY][uniqueId]) {
            return;
        }

        let newStore = {};
        newStore[STORE_KEY] = store[STORE_KEY];
        newStore[STORE_KEY][uniqueId] = defaultState;
        setStore(newStore);
    }
};